import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback } from 'react';
import { ACTION, ACTION_SUBJECT, ACTION_SUBJECT_ID, EVENT_TYPE, INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { usePopupManager } from './usePopupManager';
export var useEmojiPickerPopup = function useEmojiPickerPopup(_ref) {
  var api = _ref.api,
    buttonRef = _ref.buttonRef;
  var popupManager = usePopupManager({
    focusTarget: buttonRef,
    analytics: {
      onToggle: function onToggle(isOpen) {
        if (isOpen) {
          var _api$analytics;
          api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.fireAnalyticsEvent({
            action: ACTION.OPENED,
            actionSubject: ACTION_SUBJECT.PICKER,
            actionSubjectId: ACTION_SUBJECT_ID.PICKER_EMOJI,
            attributes: {
              inputMethod: INPUT_METHOD.TOOLBAR
            },
            eventType: EVENT_TYPE.UI
          });
        }
      }
    }
  });
  var handleSelectedEmoji = useCallback(function (emojiId) {
    var _api$emoji;
    api === null || api === void 0 || api.core.actions.focus();
    api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$emoji = api.emoji) === null || _api$emoji === void 0 ? void 0 : _api$emoji.commands.insertEmoji(emojiId, INPUT_METHOD.PICKER));
    popupManager.close();
    return true;
  }, [api, popupManager]);
  var onPopupUnmount = useCallback(function () {
    requestAnimationFrame(function () {
      return api === null || api === void 0 ? void 0 : api.core.actions.focus();
    });
  }, [api]);
  return _objectSpread(_objectSpread({}, popupManager), {}, {
    handleSelectedEmoji: handleSelectedEmoji,
    onPopupUnmount: onPopupUnmount
  });
};